import React from 'react';
import ReactDOM from 'react-dom';
import 'style/global.css';
import 'style/normalize.css'; //normalize.css 8.0.1
import 'style/resizable.css';
import App from './App';
import { Provider } from 'react-redux';
import store from './store';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
// import { configureStore } from 'store';

ReactDOM.render(
    <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Provider store={store}>
            <App />
        </Provider>
    </MuiPickersUtilsProvider>,
    document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
